import { useParams } from 'react-router-dom';

import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlan } from 'store/useBusinessToolStore/selectors';

import { getVariable } from 'helpers/environment.utils';

const EXAMPLE_PDF_UUID = getVariable('REACT_APP_ENV_EXAMPLE_PDF_UUID');
const INVESTOR_EXAMPLE_PDF_UUID = getVariable('REACT_APP_ENV_INVESTOR_EXAMPLE_PDF_UUID');

export const useExamplePreview = () => {
  const { id: businessPlanId = '' } = useParams();
  const businessPlan = useBusinessToolStore(getBusinessPlan);

  const isInvestor = businessPlan.type === BUSINESS_PLAN_TYPES.FOR_INVESTORS;
  const isExample = businessPlanId === EXAMPLE_PDF_UUID && EXAMPLE_PDF_UUID !== '';
  const isInvestorExample = businessPlanId === INVESTOR_EXAMPLE_PDF_UUID && INVESTOR_EXAMPLE_PDF_UUID !== '';

  return {
    isExamplePage: isInvestor ? isInvestorExample : isExample,
    examplePdfUUID: isInvestor ? INVESTOR_EXAMPLE_PDF_UUID : EXAMPLE_PDF_UUID,
  };
};
